import React from "react";
import { Breadcrumb, Col } from "react-bootstrap";

interface PathFolder {
  text: string;
  absolutePath: string;
}

interface DocumentBreadcrumbProps {
  pathFolders: PathFolder[];
  setCurrentPath: (path: string) => void;
}

export const DocumentBreadcrumb: React.FC<DocumentBreadcrumbProps> = ({
  pathFolders,
  setCurrentPath,
}) => (
  <Col className="ps-0">
    <div
      className="border bg-light px-2"
      style={{ lineHeight: "2.4em" }}
    >
      <Breadcrumb className="path">
        {pathFolders &&
          pathFolders.map((p) => (
            <Breadcrumb.Item
              key={p.absolutePath}
              onClick={() => {
                setCurrentPath(p.absolutePath);
              }}
            >
              {p.text}
            </Breadcrumb.Item>
          ))}
      </Breadcrumb>
    </div>
  </Col>
);
